import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppNS, Dcra } from 'app';
import { AppThunk } from '../index';
import { getInspections as getInspectionsApiCall } from '../../api/dcra-inspections/inspections';

export interface InspectionEventsState {
  inspectionEvents: Dcra.Inspection[] | [];
  isInspectionEventsLoading: boolean;
  isInspectionEventsRequested: boolean;
  isInspectionEventsSuccess: boolean;
  page: number;
  totalEntries: number;
  dateTo: string;
  dateFrom: string;
  search: string;
  searchBy: string;
  sortBy: string;
}

const initialState: InspectionEventsState = {
  inspectionEvents: [],
  isInspectionEventsLoading: false,
  isInspectionEventsRequested: false,
  isInspectionEventsSuccess: false,
  page: 1,
  totalEntries: 0,
  dateTo: '',
  dateFrom: '',
  search: '',
  searchBy: '',
  sortBy: 'date',
};

const InspectionEventsSlice = createSlice({
  name: 'dcraInspectionEvents',
  initialState,
  reducers: {
    setCurrentParams(state, action: PayloadAction<AppNS.Params>) {
      state.page = action.payload.page;
      state.dateTo = action.payload.dateTo;
      state.dateFrom = action.payload.dateFrom;
      state.search = action.payload.search;
      state.searchBy = action.payload.searchBy;
      state.sortBy = action.payload.sortBy;
    },
    inspectionEventsStart(state: InspectionEventsState) {
      state.isInspectionEventsRequested = false;
      state.isInspectionEventsLoading = true;
      state.isInspectionEventsSuccess = false;
    },
    inspectionEventsSuccess(
      state: InspectionEventsState,
      action: PayloadAction<Dcra.InspectionResult>
    ) {
      state.inspectionEvents = action ? action.payload.results : [];
      state.totalEntries = action.payload.totalEntries;
      state.isInspectionEventsRequested = true;
      state.isInspectionEventsLoading = false;
      state.isInspectionEventsSuccess = true;
    },
    inspectionEventsFailed(state: InspectionEventsState) {
      state.isInspectionEventsRequested = true;
      state.isInspectionEventsLoading = false;
      state.isInspectionEventsSuccess = false;
    },
  },
});

export const {
  setCurrentParams,
  inspectionEventsStart,
  inspectionEventsSuccess,
  inspectionEventsFailed,
} = InspectionEventsSlice.actions;

export default InspectionEventsSlice.reducer;

export const geInspectionEvents =
  (params: AppNS.Params): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(inspectionEventsStart());
      const inspectionEventsRes = await getInspectionsApiCall({ ...params });
      dispatch(inspectionEventsSuccess(inspectionEventsRes));
    } catch (err) {
      // console.error(err.toString());
      dispatch(inspectionEventsFailed());
    }
  };
